"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getFullName = (value) => {
    return `${value.firstName} ${value.middleInitial ? value.middleInitial : ''} ${value.lastName}`;
};
exports.default = getFullName;
